/**
 * Project mode (2026-10-25) — ``/api/builder/projects/{slug}/mode``.
 *
 * A project shows its reports as TABS of one page (one report group with
 * every report, one set of filters) or as a LIST in the portal sidebar
 * (each report with its own filters). Binary and never mixed; «mixed» is
 * a state from before the rule that only moving reports fixes.
 */
import { api } from "@/lib/api";

export type ProjectMode = "tabs" | "list" | "mixed";

export interface ProjectModeState {
  mode: ProjectMode;
  group_key: string | null;
  groups: string[];
  reports: string[];
  loose: string[];
}

/** What a switch does (dry run) or did (applied). */
export interface ProjectModeChange {
  applied: boolean;
  project: string;
  current: ProjectMode;
  target: "tabs" | "list";
  group_key: string | null;
  reports: string[];
  filters: string[];
  not_applicable: Record<string, string[]>;
  removed_actions: string[];
  saved_views: number;
  trimmed: string[];
  lost_aliases: string[];
  errors: string[];
}

export const projectModeApi = {
  get: (slug: string) =>
    api.get<ProjectModeState>(`/api/builder/projects/${encodeURIComponent(slug)}/mode`),
  /** ``apply: false`` = dry run: the same checks, nothing written. */
  switch: (slug: string, mode: "tabs" | "list", apply: boolean) =>
    api.post<ProjectModeChange>(`/api/builder/projects/${encodeURIComponent(slug)}/mode`, {
      mode,
      apply,
    }),
};
